import React from 'react';
import { Link, useHistory } from 'react-router-dom';
import { GoogleOAuthProvider, useGoogleLogin } from '@react-oauth/google';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { setLoginStatus, setUserInfo, setAuthInfo } from '../../../store/reducers/auth-reducer';
import googleLogo from './../../../assets/images/google-logo.png';

function getGoogleClientId() {
	return (
		process.env.REACT_APP_CLIENT_ID ||
		(typeof window !== 'undefined' && window.config?.googleClientId) ||
		''
	);
}

function mapGoogleProfileToProviderData(profile) {
	return {
		googleId: profile.sub,
		name: profile.name,
		email: profile.email,
		imageUrl: profile.picture,
		...profile,
	};
}

const GLoginInner = (props) => {
	const history = useHistory();
	const dispatch = useDispatch();

	const submitSocialLogin = (profileObj) => {
		const values = {
			provider_id: profileObj.googleId,
			provider_type: 'google',
			provider_data: profileObj,
		};
		const url = props.role === 'seller' ? 'seller/social-login' : 'user/social-login';

		axios.post(url, values).then(response => {
			toast.dismiss();
			if (response.data.status) {
				toast.success(response.data.message, { autoClose: 3000 });
				const authInfo = {
					expTime: response.data.data.expTime,
					id: response.data.data['_id'],
					token: response.data.data.token,
				};
				const userInfo = {
					name: response.data.data.name,
					email: response.data.data.email,
					seller_type: response.data.data.seller_type,
					purchase_type: response.data.data.purchase_type,
					role: response.data.data.role,
					community: response.data.data.community,
					imgUrl: response.data.data.image_url,
				};
				localStorage.setItem('userInfo', JSON.stringify(userInfo));
				localStorage.setItem('authInfo', JSON.stringify(authInfo));
				localStorage.setItem('isLoggedIn', 1);
				dispatch(setLoginStatus({ isLoggedIn: true }));
				dispatch(setUserInfo({ userInfo }));
				dispatch(setAuthInfo({ authInfo }));

				if (props.role === 'user') {
					props.closeModal();
					history.push('/');
				} else if (props.role === 'seller') {
					history.push('/seller/dashboard');
				}
			} else {
				toast.error(response.data.message, { autoClose: 3000 });
			}
		}).catch(error => {
			toast.dismiss();
			if (error.response) {
				toast.error(error.response.data.message, { autoClose: 3000 });
			}
		});
	};

	const handleGoogleLogin = useGoogleLogin({
		onSuccess: async (tokenResponse) => {
			try {
				const { data: profile } = await axios.get(
					'https://www.googleapis.com/oauth2/v3/userinfo',
					{ headers: { Authorization: `Bearer ${tokenResponse.access_token}` } }
				);
				submitSocialLogin(mapGoogleProfileToProviderData(profile));
			} catch (error) {
				console.error('Google social login error:', error);
				toast.error('Google sign-in failed. Please try again.');
			}
		},
		onError: (error) => {
			console.error('Google authentication error:', error);
			toast.error('Google sign-in was cancelled or failed.');
		},
		scope: 'openid profile email',
		flow: 'implicit',
	});

	return (
		<Link
			to="#"
			onClick={(e) => {
				e.preventDefault();
				handleGoogleLogin();
			}}
			className="d-inline-block me-2"
		>
			<img src={googleLogo} alt="google-logo" />
		</Link>
	);
};

const GLogin = (props) => {
	const clientId = getGoogleClientId();

	if (!clientId) {
		return (
			<span className="d-inline-block me-2" title="Google login is not configured">
				<img src={googleLogo} alt="google-logo" style={{ opacity: 0.5 }} />
			</span>
		);
	}

	return (
		<GoogleOAuthProvider clientId={clientId}>
			<GLoginInner {...props} />
		</GoogleOAuthProvider>
	);
};

export default GLogin;
